import enLocale from '@jd/element-ui/lib/locale/lang/en';
import zhLocale from '@jd/element-ui/lib/locale/lang/zh-CN';
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import VueCookie from 'vue-cookie';
import JElementUI from '@jd/element-ui/lib/element-ui.common';
import myEn from './i18n/en-US.js';
import myZh from './i18n/zh-CN.js';

Vue.use(VueI18n);

const messages = {
  en: Object.assign({}, myEn, enLocale),
  zh: {
    ...myZh,
    ...zhLocale
  }
};

const i18n = new VueI18n({
  locale: VueCookie.get('jdcloud_sitelang') || 'cn',
  fallbackLocale: 'zh',
  messages, // set locale messages
});

Vue.use(JElementUI, {
  i18n: (key, value) => i18n.t(key, value)
});

export const PopStatus = {
  'NONE': 1, /* 默认状态 */
  'TURN_ON': 2, /* 开机 */
  'TURN_OFF': 3, /* 关机 */
  'RESTART': 4, /* 重启 */
  'RESET_PASSWORD': 5, /* 重置密码 */
  'REINSTALL': 6, /* 重装系统 */
  'BANDWIDTH': 7, /* 调整公网带宽 */
  'SOS':8,/*SOS*/
  'FIXSOS':9,/*修复SOS*/
  'RESETSOS':10,/*重置sos*/
  'RENEW': 11, /* 续费 */
  'UNBIND': 12, /* 解绑资源 */
  'EDIT_TAG': 13, /* 编辑标签 */
  'DELETE': 14, /* 删除 */
  'turnOnDeleteProtect': 15,
  'turnOffDeleteProtect': 16,
};

/**
 * 子网操作下拉选
 * @type {{DELETE: number}}
 */
export const SubnetOperationConstant = {
  'DELETE': 1, /* 删除 */
  'ENABLEIPV6': 2/* 开通ipv6 */
};

/**
 * 弹性IP操作下拉选
 * @type {{BIND: number, UNBIND: number, MODIFY: number}}
 */
export const EipOperationConstant = {
  'BIND': 1, /* 绑定资源 */
  'UNBIND': 2, /* 解绑资源 */
  'MODIFY': 3, /* 修改带宽 */
  'RENEW': 4, /* 续费 */
  'DELETE': 5, /* 删除 */
  'EDITTAG': 6, /*编辑标签*/
  'JOINSHARED': 7, /* 加入共享带宽 */
  'REMOVESHARED': 8, /* 移除共享带宽 */
};

/**
 * 共享带宽操作下拉选
 * @type {{ADDIP: number, REMOVEIP: number, MODIFY: number}}
 */
export const SbwOperationConstant = {
  'ADDIP': 1, /* 添加IP */
  'REMOVEIP': 2, /* 移除IP */
  'MODIFY': 3, /* 修改带宽 */
  'RENEW': 4, /* 续费 */
  'DELETE': 5, /* 删除 */
  'EDITTAG': 6, /*编辑标签*/
  'REMOVESHARED': 7, /* 移除共享带宽 */
};

/**
 * 共享带宽添加ip最大值
 * @type number
 */

 export const SbwAddIpMaxCount = 300;

/**
 * ipv6操作下拉选
 * @type {{MANAGE: number}}
 */
export const Ipv6OperationConstant = {
  'MANAGE': 1, /* 管理IPv6地址 */
};

/**
 * 区分创建云物理服务器和弹性IP和负载均衡的常量
 * @type {{BASIC: string, VPC: string, EIP: string}}
 */
export const CreateTypeConstant = {
  'BASIC': 'basic', /* 基础网络实例 */
  'VPC': 'vpc', /* 私有网络实例 */
  'EIP': 'eip', /* 弹性IP */
  'CPSEIP': 'cpseip',
  'SLB': 'cpslb', /* 负载均衡 */
  'IPV6': 'ipv6Address', /* ipv6 */
  'NAT': 'cpsnat',
  'SBW': 'bandwidthPackage', /* 共享带宽 */
  'PEERING': 'cpspeering' , /* 对等连接 */
};

/**
 *区分列表页查询基础网络实例/私有网络实例的常量
 * @type {{BASIC: string, VPC: string}}
 */
export const NetworkTypeConstant = {
  'BASIC': 'basic', /* 基础网络实例 */
  'VPC': 'vpc', /* 私有网络实例 */
  'IPV6': 'ipv6' /* ipv6网关 */
};

/**
 * 付费方式
 * @type {{PREPAID_BY_DURATION: VueI18n.TranslateResult}}
 */
export const ChargeModeMap = {
  PREPAID_BY_DURATION: i18n.t('detail.text.prepaid_by_duration'), /* 包年包月 */
  POSTPAID_BY_DURATION: i18n.t('create.text.byConfigurations'),/* 按配置 */
  POSTPAID_BY_USAGE: i18n.t('create.text.byQuantities')/* 按用量 */
};

/**
 * 地域对应关系
 * @type {{"CN-EAST-1": VueI18n.TranslateResult, "CN-NORTH-1": VueI18n.TranslateResult}}
 */
export const RegionMap = {
  'CN-EAST-1': i18n.t('detail.text["cn-east-1"]'),
  'CN-NORTH-1': i18n.t('detail.text["cn-north-1"]'),
};

/**
 * 弹性IP是否绑定
 * @type {{DISASSOCIATE: string, ASSOCIATE: string}}
 */
export const EIPAssociateConstant = {
  'DISASSOCIATE': 'disassociate',
  'ASSOCIATE': 'associate'
};

/**
 * VPC实例是否绑定EIP
 * @type {{YES: string, NO: string}}
 */
export const EnableInternetConstant = {
  'YES': 'yes',
  'NO': 'no'
};

/**
 * 实例类型对应中文
 * @type {{CPS: VueI18n.TranslateResult}}
 */
export const InstanceTypeConstant = {
  'CPS': i18n.t('eip.text.cps'),
  'VPC': i18n.t('privateNetInstance.privateNet'),
  'CPSLB': i18n.t('slb.text.slb'),
  'CPSNAT': i18n.t('nat.text.nat'),
};

/**
 * appCode
 * @type {{AIDC: string}}
 */
export const AppCodeConstant = {
  'AIDC': 'aidc'
};

/**
 **@disc: 国际化Cookie
 */
export const CookieConstant = {
  'JDCLOUD_SITELANG': 'jdcloud_sitelang'
};

/** ****************************SLB相关***************************** */
/**
 **@disc:调度算法对应中文名字
 */
export const AlgorithmNameMapConstant = {
  'WRR': i18n.t('slb.text.roundRobin'), // 加权轮询
  'WLC': i18n.t('slb.text.leastConnections'), // 加权最小连接数,
  'CONHASH': i18n.t('slb.text.conhash'), // 源IP
  'IPHASH': i18n.t('slb.text.ipHash'), // IP哈希
};

/**
 **@disc:开启关闭对应中文
 */
export const OnOrOffMapConstant = {
  'ON': i18n.t('slb.text.opened'), // 开启
  'OFF': i18n.t('slb.text.closed'), // 关闭
};

/**
 **@disc:开启关闭选择项
 */
export const SwitchConstant = [
  {
    'label': i18n.t('slb.text.opened'), // 开启
    'value': 'on',
  },
  {
    'label': i18n.t('slb.text.closed'), // 关闭
    'value': 'off',
  },
];
/**
 **@disc:监听器状态：运行或停止对应中文
 */
export const RunningOrStoppedConstant = {
  'ACTIVE': i18n.t('slb.text.opened'), // 开启
  'INACTIVE': i18n.t('slb.text.closed'), // 关闭
};

/**
 **@disc:编辑名称状态有效或者错误
 */
export const ValidOrErrorConstant = {
  'VALID': 'success',
  'ERROR': 'error',
  'NONE': 'none'
};

/**
 **@disc:监听器对应操作
 */
export const ListenerOperationConstant = {
  'EDIT': 1, /* 编辑 */
  'OPEN': 2, /* 开启 */
  'CLOSE': 3, /* 关闭 */
  'DELETE': 4 /* 删除 */
};

/**
 **@disc: 负载均衡实例对应的后端服务器状态
 **@params:
 */
export const BackendServerConstant = {
  'HEALTHY': i18n.t('detail.text.normal'), // 正常
  'UNHEALTHY': i18n.t('detail.text.abnormal') // 异常
};

/**
 **@disc: 两种IP地址，格式化名称映射
 **@params:
 */
export const IpVersionConstant = {
  'ipv4': 'IPv4',
  'ipv6': 'IPv6'
};

/**
 **@disc: SLB操作
 **@params:
 */
export const SlbOperationConstant = {
  'UNBIND': 1, /* 解绑公网IP */
  'OPEN': 2, /* 开启 */
  'CLOSE': 3, /* 关闭 */
  'RENEW': 4, /* 续费 */
  'DELETE': 5, /* 删除 */
  'EDITTAG': 6 /* 编辑标签 */
};

export const CookiesConstant = {
  'INSERT': i18n.t('slb.text.setCookie'),
  'REWRITE': i18n.t('slb.text.rewriteCookie')
};

/**
 **@disc:中英文cookie
 */
export const I18nConstant = {
  'CN': 'cn',
  'EN': 'en'
};

/**
 **@disc:黑白名单map
 */
export const WhiteBlackListNameConstant = {
  'white': i18n.t('slb.text.whiteList'),
  'black': i18n.t('slb.text.blackList'),
};

/**
 **@disc:黑白名单list
 */
export const WhiteBlackListNames = [
  { label: i18n.t('slb.text.whiteList'), value: 'white' },
  { label: i18n.t('slb.text.blackList'), value: 'black' },
];
/**
 **@disc: 接入操作保护的操作
 */
export const OperationConstant = {
  'REINSTALL': 'cps:reinstallInstance',
  'RESTART': 'cps:restartInstance',
  'STOP': 'cps:stopInstance',
  'DELETE': 'cps:deleteInstance',
  'DELETE_EIP': 'cps:deleteelasticIp',
  'DELETE_SLB': 'cps:deleteLoadBalancer',
  'DELETE_IPV6': 'cps:deleteIpv6AddressBandwidth',
  'DELETE_NAT': 'cps:deleteNatGateway',
  'DELETE_CERT' :'cps:deleteCertificate',
  'BATCH_DELETE':'cps:removeInstances',
  'BATCH_STOP':'cps:stopInstances',
  'BATCH_RESTART':'cps:restartInstances',
  'DELETE_SBW': 'cps:deleteBandwidthPackage',
};

/**
 **@disc: 实例机器对应中文状态
 */
export const InstanceStatusMapConstant = {
  'starting': i18n.t('listPage.text.powerIn'),
  'running': i18n.t('listPage.text.run'),
  'stopping': i18n.t('listPage.text.shuttingDown'),
  'stopped': i18n.t('listPage.text.shutdown'),
  'restarting': i18n.t('listPage.text.rebooting'),
  'creating': i18n.t('listPage.text.creating'),
  'destroying': i18n.t('listPage.text.destroying'),
  'upgrading': i18n.t('listPage.text.reconfiging'),
  'reinstalling': i18n.t('listPage.text.reinstalling'),
};

/**
 **@disc: nat网关规格
 */
export const SpecificationType = [
  { label: i18n.t('nat.text.small'), value: 's' },
  { label: i18n.t('nat.text.middle'), value: 'm' },
  { label: i18n.t('nat.text.large'), value: 'l' },
  { label: i18n.t('nat.text.xlarge'), value: 'xl' },
];
/**
 **@disc: nat网关规格修改
 */
export const SpecificationTypes = [
  { label: i18n.t('nat.text.small'), value: 'small' },
  { label: i18n.t('nat.text.middle'), value: 'medium' },
  { label: i18n.t('nat.text.large'), value: 'large' },
  { label: i18n.t('nat.text.xlarge'), value: 'xlarge' },
];

/**
 **@disc: SpecificationTypeParam
 */
export const SpecificationTypeParams = {
  'small': i18n.t('nat.text.small'),
  'medium': i18n.t('nat.text.middle'),
  'large': i18n.t('nat.text.large'),
  'xlarge': i18n.t('nat.text.xlarge'),
};

/**
 **@disc: 可用区
 */
export const azName = {
  'cn-north-1a': i18n.t('nat.az.azNameA'),
  'cn-east-jdt1a': i18n.t('nat.az.azNameA'),
  'cn-north-1b': i18n.t('nat.az.azNameB'),
  'cn-north-1c': i18n.t('nat.az.azNameC'),
};
/**
 **@disc: SNAT最大连接数
 */
export const SpecificationTypeSnatMax = {
  's': 5,
  'm': 20,
  'l': 50,
  'xl': 100,
};

/**
 **@disc: SpecificationTypeParams
 */
export const SpecTypeParamsDicts = {
  'small': 5,
  'medium': 20,
  'large': 50,
  'xlarge': 100,
};

/**
 **@disc: SpecificationTypeParams
 */
export const SpecTypeParamsDict = {
  'small': 's',
  'medium': 'm',
  'large': 'l',
  'xlarge': 'xl',
};

/**
 **@disc: SpecificationTypeParams
 */
export const SpecificationTypeParamsDict = {
  's': 'small',
  'm': 'medium',
  'l': 'large',
  'xl': 'xlarge',
};
/**
 **@disc: 协议Map
 */
export const ProtocolMapConstant = {
  'TCP': 'tcp',
  'UDP': 'udp',
  'HTTP': 'http',
  'HTTPS': 'https'
};

/**
 **@disc: SSH操作常数
 */
export const SSHOperationConstant = {
  'DELETE': 1
};

/**
 **@disc: ServiceCodeConstant
 */
export const ServiceCodeConstant = {
  'CPS': 'cps',
  'CPSEIP': 'cpseip',
  'CPS|EIP': 'cps|cpseip',
  'CPSSSH': 'cpsssh',
  'CPSVPC': 'cpsvpc',
  'CPSLB': 'cpslb',
  'CPSNAT': 'cpsnat',
  'CPSBW': 'cpsbw',
  'EIP|NAT': 'cpseip|cpsnat',
  'CPSPEERING': 'cpspeering'
};

/**
 **@disc: 禁用掉操作的两种状态
 **@author: mengln
 */
export const OverdueConstantArray = [
  'overdue_stop', // 到期停服
  'arrear_stop', // 欠费停服
];


/**
 **@disc: 按配置提示红字的两种状态
 **@author: mengln
 */
export const ArrearConstantArray = [
  'arrear', // 欠费
  'arrear_stop', // 欠费停服
];

// ("normal","正常");
// ("overdue","过期"); 包年包月 prepaid_by_duration
// ("arrear","欠费"); 按配置 postpaid_by_duration
// ("overdue_stop","过期停服"); 包年包月 prepaid_by_duration
// ("arrear_stop","欠费停服"); 按配置 postpaid_by_duration

/**
 **@disc: 校验密码通用正则
 * 2024年12月27日，经过产品测试前后端共同商丘，前端将所有密码生产规则和校验规则都去掉特殊字符串^
 */
// export const PasswordRuleConstant = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[\d\*\(\)`~!@#\$%^&_\-+=\|\{\}\[\]:\";\'<>,.\?\/\）])[a-zA-Z\d\*\(\)`~!@#\$%^&_\-+=\|\{\}\[\]:\";\'<>,.\?\/\）]{8,30}$/;
export const PasswordRuleConstant = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[\d\*\(\)`~!@#\$%&_\-+=\|\{\}\[\]:\";\'<>,.\?\/\）])[a-zA-Z\d\*\(\)`~!@#\$%&_\-+=\|\{\}\[\]:\";\'<>,.\?\/\）]{8,30}$/;

/**
 **@disc: 上传文件错误码
 */
export const UploadFileErrorConstant = {
  'uploadFileFormatError': 20201,
  'uploadFileSizeError': 20202,
  'uploadFileBase64': 20203,
  'uploadFileNotBase64': 20204
};


/**
 **@disc: 计费方式常数
 */
export const BillingTypesConstant = {
  'PREPAID_BY_DURATION': 3, // 包年包月
  'POSTPAID_BY_DURATION': 1, // 按配置后付费
  'QUANTITIES_BY_DURATION': 2, //按用量
};

/**
 **@disc: 又一个区分包年包月或者配置的参数
 */
export const PayTypeConstant = {
  'PRE_PAID': 1,
  'POST_PAID': 2
};

export const ChargeModeConstant = {
  PREPAID_BY_DURATION: 'prepaid_by_duration', // 包年包月 预付费
  POSTPAID_BY_DURATION: 'postpaid_by_duration', // 按配置 后付费
  ENHANCED_BY_DURATION: 'postpaid_by_usage', // 按用量 后付费
};

/**
 **@disc: 检查别名IP报错常数
 */
export const AddAliasIpErrorConstant = {
  'CIDR_NOT_STANDARD': 'cidr_not_standard',
  'CIDR_OUT_OF_RANGE': 'cidr_out_of_range',
  'CIDR_OVERLAP': 'cidr_overlap',
  'CIDR_IS_RETAIN': 'cidr_is_retain',
  'QUOTA_EXCEEDED': 'quota_exceeded',
  'CIDR_IS_NETWORK_IP': 'cidr_is_network_ip',
  'CIDR_IS_GATEWAY_IP': 'cidr_is_gateway_ip',
  'CIDR_IS_BROADCAST_IP': 'cidr_is_broadcast_ip',
};

/**
 **@disc: 别名IP操作常数
 */
export const AliasIpOperationConstant = {
  'DELETE': 1
};

/**
 **@disc: 校验别名IP范围正则
 */
export const AliasIpRuleConstant = /^(10|11|172|192)\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})\/([1-9]|[1-2]\d|3[0-2])$/;

export const Ipv6RuleConstant = /^((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))$/


/**
 **@disc: 目标网络接口名称
 */
export const TargetNetworkInterfaceName = {
  'primaryNetworkInterface': '1', // 主网口
  'SecondaryNetworkInterface': '2' // 辅网口
};

/**
 **@disc: 校验CIDR通用正则
 */
export const CidrRuleConstant = /^(10|11|172|192)\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})\/(1[6-9]|2[0-8])$/;

/**
 **@disc: 可用目标内网IP地址渠道常量
 */
export const TargetIpAddressChannelConstant = {
  'EIP': 'eip',
  'VMSG': 'vmsg'
};



/**
 **@disc: 对等连接状态常量
 */
export const PeeringStatus = {
};

/**
 **@disc: 对等连接列表页搜索框条件
 */
export const PeeringSearchConditions = [
    {
        searchValue: 'peeringName',
        searchLabel: i18n.t('peering.text.peeringName')
    },
    {
        searchValue: 'peeringId',
        searchLabel: i18n.t('peering.text.peeringId')
    }
];


/**
 **@disc: 对等连接账号类型
 */
export const AccountTypes = [
    {
        value: 'same',
        label: i18n.t('peering.text.sameAccount')
    },
    {
        value: 'different',
        label: i18n.t('peering.text.differentAccount')
    }
];

/**
 **@disc: 对端账号类型
 */
export const oppositeAccountType = {
  "1": i18n.t('peering.text.sameAccount'), //同账号
  "0": i18n.t('peering.text.differentAccount') //跨账号
}

/**
 **@disc: 对等连接发送端和接收端是否同一账号
 */
export const SameTenant = {
    "1": true, //同一账号
    "0": false //不同账号
};

/**
 **@disc: 对等连接发送端和接收端是否同一region
 */
export const SameRegion = {
    "1": true, //同一地域
    "0": false //不同地域
};

/**
 **@disc: 对等连接登陆用户角色
 */
export const AccountRoles = {
    "sender": 0, //发起方
    "receiver": 1, // 接收方
};


/**
 * 对等连接操作项
 * @type {{ADDIP: number, REMOVEIP: number, MODIFY: number}}
 */
export const PeeringOperationConstant = {
  'ACCEPT': 1, /* 接受 */
  'REJECT': 2, /* 拒绝 */
  'MODIFY': 3, /* 修改带宽 */
  'DELETE': 4, /* 删除 */
};

/**
 * 对等连接状态对应类名
 * @type {{ADDIP: string, REMOVEIP: string, MODIFY: string}}
 */
export const PeeringStatusClass = {
  "applied": "jc-status-warning", /* 待接收 */
  "connected": "jc-status-success", /* 已连接 */
  "accepting": "jc-status-success", /* 申请中 */
  "rejected": "jc-status-warning", /* 已拒绝 */
  "deleted_by_receiver,deleted_by_sender": "jc-status-warning", /* 对端已删除 */
  "initializing": "my-status-middle", /* 初始化（下发配置中） */
  "expired": "jc-status-danger", /* 已失效 */
  "in_arrears": "jc-status-danger", /* 欠费中（欠费断开） */
  "abnormal": "jc-status-danger", /* 异常 */
  "error": "jc-status-danger", /* 错误 */
};

/**
 **@disc: 自定义分区系统盘和数据盘最大分区值常量
 */
export const partitionsMaxConstant = {
  'system': 5,
  'data': 3
};


/**
 **@disc: 当前机器是否支持自定义分区,0：支持，1：不支持
 */

export const CustomPartitionSupportConstant = {
  "0": true,
  "1": false
};

// 计费操作类型 1、创建；2、续费；3、升降配；4、删除
export const BillingOperateTypeConstant = {
  "create": 1,
  "renew":  2,
  "modify": 3,
  "delete": 4,
};


// 实例删除保护状态
export const DeleteProtectStatusConstant = {
  "yes": i18n.t('privateNetInstance.deleteProtectOn'),
  "no":  i18n.t('privateNetInstance.deleteProtectOff'),
};


/**
 * 报警状态常量
 *
 */

export const alarmStatusConstant = {
  "0": i18n.t('detail.text.unhandled'), /* 未处理 */
  "1": i18n.t('detail.text.recovered'), /* 已恢复 */
  "2": i18n.t('detail.text.ignored'), /* 已忽略 */
};


/**
 * 镜像状态常量
 *
 */
export const MirrorStatusConstant = [
    {
      "text": i18n.t('mirror.text.availableStatus'),
      "value": "available"
    },
    {
      "text": i18n.t('mirror.text.errorStatus'),
      "value": "error"
    }
];

/**
 * 镜像类型常量
 *
 */
export const MirrorTypesConstant = [
    {
      "text": i18n.t('mirror.text.commonMirror'),
      "value": "common"
    },
    {
      "text": i18n.t('mirror.text.privateMirror'),
      "value": "private"
    }
];

/**
 * 公共/定制镜像类型常量
 *
 */
export const PublicMirrorTypesConstant = [
    {
      "text": i18n.t('mirror.text.publicMirror'),
      "value": "public"
    },
    {
      "text": i18n.t('mirror.text.customizeMirror'),
      "value": "customize"
    }
];
/**
 * 镜像操作下拉选
 * @type {{DELETE: number}}
 */
export const MirrorOperationConstant = {
    'DELETE': 1, /* 删除 */
    'CREATE': 2, /* 创建实例*/
};


/**
 * Snat规则粒度
 *
*/
export const SnatRuleGranularityConstant = [
  { 'label': i18n.t('nat.text.subnetGranularity'), 'value': 'subnet' },
  { 'label': i18n.t('nat.text.serverGranularity'), 'value': 'server' },
  { 'label': i18n.t('nat.text.customGranularity'), 'value': 'custom' },
];

/**
 * nat规则类型
 *
*/
export const NatRuleConstant = {
  'SNAT': 'snat',
  "DNAT": 'dnat'
};

/**
 * dnat端口类型
 *
*/
export const DnatPortTypeConstant = [
  { 'label': i18n.t('nat.text.allPort'), 'value': 'IP' },
  { 'label': i18n.t('nat.text.specific'), 'value': 'PORT' },
];

/**
 * dnat支持协议
 *
*/
export const DnatProtocolConstant = [
  { 'label': 'TCP', 'value': 'TCP' },
  { 'label': 'UDP', 'value': 'UDP' },
];


/**
 **SNAT规则粒度映射
 */
 export const SnatRuleGranularityMapConstant = {
  'subnet': i18n.t('nat.text.subnetGranularity'), // 子网粒度
  'server': i18n.t('nat.text.serverGranularity'), // 服务器粒度
  'custom': i18n.t('nat.text.customGranularity'), // 自定义粒度
};
/**
* 带宽计费方式
*/
export const BandWidthPaymentTypeConstant = [
    {
      "text": i18n.t('create.placeholder.fixedBandwidth'),
      "value": "fixed"
    }
];

/**
* 按用量带宽计费方式
*/
export const BandWidthPaymentTypeByQuantitiesConstant = [
  {
    "text": i18n.t('create.placeholder.enhanced95'),
    "value": "enhanced"
  }
];
/**
* 保底百分比
*/
export const GuaranteedPercentageConstant = [
    {
      "text": "20%",
      "value": "20"
    }
];

/**
* 计费方式
*/
export const TimeUnitConstant = [
    {
        'value': 1,
        "label": '按小时' // 按小时
    },
    {
        'value': 3,
        "label": '按月' // 包月
    },
];

/**
* 游戏服务器地域白名单
*/

export const GameRegionsConstant = [
'cn-north-1'
];




// WEBPACK FOOTER //
// ./src/common/Constants.js